import React from "react";
import { useHistory } from "react-router-dom";

import Header from "../../../../components/molecules/Header";
import useStyles from "./style";
import ImageAva from "../../../../assets/images/image-avatar";

import {
  Container,
  Grid,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

const PusatBantuan = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Header
        type="with-title"
        title="Pusat Bantuan"
        onClick={() => history.push("/akun")}
      />
      <Container>
        <Grid container spacing={1} className={classes.wrapHeader}>
          <Grid item xs={12} sm={4} md={4}>
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12} className={classes.wrapAvatar}>
                <ImageAva />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.bantuanButton}
                style={{ marginTop: "40px" }}
              >
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#27AE60", color: "#fff" }}
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send/?phone=6281268000433&text=halo+support+tokorame%2C+saya+perlu+bantuan&app_absent=0"
                    )
                  }
                >
                  whatsapp
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.bantuanButton}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => window.open("mailto:halo@tokorame.co.id")}
                >
                  email
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={8} md={8} className={classes.header_text}>
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12}>
                <h2>Butuh Bantuan?</h2>
                <p>
                  TokoRame siap membantu temen-teman reseller. jam kerja Senin -
                  Sabtu,Jam 08.00 - 17.00 WIB
                </p>
              </Grid>
              <hr
                style={{ border: "5px solid #efefef", margin: "0" }}
                width="100%"
              />
              <Grid item xs={12} sm={12} md={12}>
                <List component="nav" className={classes.listText}>
                  <ListItem
                    button
                    onClick={() =>
                      window.open("https://tokorame.co.id/blog/faq")
                    }
                  >
                    <ListItemText primary="Daftar Pertanyaan Yang Sering Ditanyakan" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() =>
                      window.open("https://tokorame.co.id/terms-and-conditions")
                    }
                  >
                    <ListItemText primary="Syarat dan Ketentuan" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() =>
                      window.open("https://tokorame.co.id/privacy-policy")
                    }
                  >
                    <ListItemText primary="Kebijakan Privasi" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => window.open("https://tokorame.co.id/about")}
                  >
                    <ListItemText primary="Tentang Kami" />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item className={classes.header_text_mini}>
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12}>
                <h2>Butuh Bantuan?</h2>
                <p>
                  TokoRame siap membantu temen-teman reseller. jam kerja Senin -
                  Sabtu,Jam 08.00 - 17.00 WIB
                </p>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.bantuanButton_mini}
              >
                <Button
                  variant="contained"
                  style={{ backgroundColor: "#27AE60", color: "#fff" }}
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send/?phone=6281268000433&text=halo+support+tokorame%2C+saya+perlu+bantuan&app_absent=0"
                    )
                  }
                >
                  whatsapp
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                className={classes.bantuanButton_mini}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => window.open("mailto:halo@tokorame.co.id")}
                >
                  email
                </Button>
              </Grid>
              <hr
                style={{
                  border: "5px solid #efefef",
                  marginBottom: "0",
                  marginTop: "20px",
                }}
                width="100%"
              />
              <Grid item xs={12} sm={12} md={12}>
                <List component="nav" className={classes.listText}>
                  <ListItem
                    button
                    onClick={() =>
                      window.open("https://tokorame.co.id/blog/faq")
                    }
                  >
                    <ListItemText primary="Daftar Pertanyaan Yang Sering Ditanyakan" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() =>
                      window.open("https://tokorame.co.id/terms-and-conditions")
                    }
                  >
                    <ListItemText primary="Syarat dan Ketentuan" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() =>
                      window.open("https://tokorame.co.id/privacy-policy")
                    }
                  >
                    <ListItemText primary="Kebijakan Privasi" />
                  </ListItem>
                  <Divider />
                  <ListItem
                    button
                    onClick={() => window.open("https://tokorame.co.id/about")}
                  >
                    <ListItemText primary="Tentang Kami" />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PusatBantuan;
